import { render, staticRenderFns } from "./Block_Dynamic_link.vue?vue&type=template&id=1f3bd5cf&"
import script from "./Block_Dynamic_link.vue?vue&type=script&lang=js&"
export * from "./Block_Dynamic_link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports